import { APP_PATH } from 'modules/app/constants'
import { getObjectUtil } from 'packages/src'

const getUserAgentAppSelect = state => {
  return getObjectUtil(state, APP_PATH.USER_AGENT)
}

export default getUserAgentAppSelect
